import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import EntryPublicSchema from "@common/schema/entry/public";
import * as Section from "@repoflow/components/section";
import * as QueriesQL from "queries/entry";
import { dayLabel, isDay } from "components/day/dates";
import * as ViewRoute from "./view";
import * as RemoveRoute from "./remove";

// One entry: edit it, or remove it. Reached from its day, and its crumbs lead
// back there — an entry has no listing of its own to return to.
//
// The day is read off the id rather than from the query, so the crumb is right
// before the row has loaded: `entryId` is `<date>-<suffix>` by construction.
const dayOf = (entryId) => String(entryId || "").slice(0, 10);

const LocalProvider = ({
  match: {
    params,
    params: { entryId },
  },
  children: Children,
}) => {
  const base = `/entry/${entryId}`;
  const basepath = `/entry/:entryId`;

  // Keyed on the entity. The screen below seeds its form state ONCE, from the
  // entry this route resolved, so moving from one entry to another has to
  // reset it — see Section.Provider.
  return (
    <Section.Provider
      key={entryId}
      schema={EntryPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"entries.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath, params: { entryId } }) => {
        const day = dayOf(entryId);
        return (
          <>
            <BreadcrumbItem>
              <Link to={`/day`}>Food log</Link>
            </BreadcrumbItem>
            {isDay(day) ? (
              <BreadcrumbItem>
                <Link to={`/day/${day}`}>{dayLabel(day)}</Link>
              </BreadcrumbItem>
            ) : null}
            <Switch>
              <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
              <Route path={`${basepath}`} component={ViewRoute.Indice} />
            </Switch>
          </>
        );
      }}
    </LocalProvider>
  );
}

export { dayOf };

export const Sidebar = () => <></>;
